import { PageTitle } from '@/components/ui';
import { useRequireB2CPermission } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { useCreateProfessionalUnavailability } from '@/services/mutations/professional-unavailability';
import { formatDateForInput } from '@/utils';
import { CreateUnavailabityForm } from './components/CreateUnavailabityForm';

const CreateProfessionalUnavailability = () => {
	const navigate = useNavigate();
	const { isLoading, canManageAvailability } = useRequireB2CPermission();
	console.log(
		'Pai renderizado - Verificando se navigate existe:',
		!!navigate,
	);

	const { mutate, isSuccess } = useCreateProfessionalUnavailability();

	const handleSubmit = (data: ProfessionalUnavailabilitys.Create) => {
		// Garante a formatação antes de enviar para a API
		const formattedStartDate = formatDateForInput(data.start_date);
		const formattedEndDate = formatDateForInput(data.end_date);

		mutate({
			...data,
			start_date: formattedStartDate,
			end_date: formattedEndDate,
		});
	};

	if (isLoading || !canManageAvailability) {
		return null;
	}

	return (
		<section className="w-full space-y-6 px-4 py-6 md:max-w-4xl">
			<PageTitle text="Calendário" />

			<div className="w-full space-y-4">
				<div>
					<h2 className="text-lg font-bold text-stone-900">
						Criar indisponibilidade
					</h2>
					<p className="text-stone-500">
						Programe seu período de folga ou indisponibilidade
					</p>
				</div>

				<CreateUnavailabityForm
					onAction={handleSubmit}
					isSuccess={isSuccess}
					onCancel={() => navigate('/profissional/horarios')}
				/>
			</div>
		</section>
	);
};

export { CreateProfessionalUnavailability };
